<template>
  <v-app>
    <v-main :style="{ 'background-color': getBackgroundColor }">
      <!-- En-tête : barre blanche épurée (logo, fil d'Ariane, connexion, utilisateur) -->
      <v-app-bar
        app
        fixed
        flat
        height="58"
        class="acc-bar"
        style="z-index: 1; left: 0px"
        v-if="
          getApp != 'LOGIN' &&
          getApp.includes('/') == false &&
          getApp != 'SIGNATURE DOUBLE AUTHENTIFICATION' &&
          showHeader
        "
      >
        <div class="acc-bar-in">
          <button v-if="getApp != ''" type="button" class="acc-icon-btn" title="Retour aux applications" @click="goTo('/')">
            <v-icon size="20">mdi-arrow-left</v-icon>
          </button>
          <div class="acc-logo" title="Applications" @click="goTo('/')">A</div>
          <!-- Accueil : la marque ; dans un module : Applications › module -->
          <div v-if="getApp == ''" class="acc-brand">
            <b>ACCEN</b><span>Web applications</span>
          </div>
          <div v-else class="acc-crumb">
            <a class="acc-crumb-home" @click="goTo('/')">Applications</a>
            <v-icon size="16" class="acc-crumb-sep">mdi-chevron-right</v-icon>
            <span class="acc-crumb-cur">
              <v-icon size="18" :icon="currentApp.icon"></v-icon>{{ currentApp.text }}
            </span>
          </div>
          <div class="acc-sp"></div>
          <WifiState pill></WifiState>
          <div v-if="userName" class="acc-user" :title="userName">
            <span class="acc-av">{{ userInitials }}</span><span class="acc-user-name">{{ userName }}</span>
          </div>
          <button type="button" class="acc-icon-btn acc-logout" title="Déconnexion" @click="logOut()">
            <v-icon size="20">mdi-logout</v-icon>
          </button>
        </div>
      </v-app-bar>
      <v-col class="pa-0">
        <v-card :variant="'text'">
          <!-- <v-card :variant="'text'" :style="showHeader ? 'height: 94.5vh; overflow-y: auto' : ''"> -->
          <v-col class="pa-1 pt-2 pb-0">
            <router-view v-if="!isLoading" />
            <div v-else>
              <v-col align="center" style="margin-top: 35vh" class="py-0">
                <v-progress-circular
                  size="110"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-col>
            </div>
          </v-col>
        </v-card>
      </v-col>
    </v-main>
  </v-app>
</template>

<script>
import engine from "@/core/index";
import WifiState from "@/components/show_internet_state.vue";

export default {
  // name: "",
  data() {
    return {
      selectedPage: undefined,
      isLoading: true,
      webApplicationToShow: [],
      items: [
        {
          text: "Planning Disponibilité",
          href: "planning-disponibilite",
          color: "#66BB6A",
          icon: "mdi-calendar-month",
          show: false,
        },
        {
          text: "Planning Livraison",
          href: "planning-livraison",
          color: "#66BB6A",
          icon: "mdi-calendar-month",
          show: false,
        },
        {
          text: "Planning Opérateurs",
          href: "planning-operateur",
          color: "#66BB6A",
          icon: "mdi-calendar-month",
          show: false,
        },
        {
          text: "Planning gestion RDV vélo",
          href: "planning-gestion-rdv-velo",
          color: "#66BB6A",
          icon: "mdi-calendar-month",
          show: false,
        },
        {
          text: "Statistiques",
          href: "statistiques",
          color: "#FFF176",
          icon: "mdi-chart-bar",
          show: false,
        },
        {
          text: "Email visualisation",
          href: "email-visualisation",
          color: "#5C6BC0",
          icon: "mdi-email",
          show: false,
        },
        {
          text: "Etat des lieux materiel",
          href: "etat-des-lieux-materiel",
          color: "#8D6E63",
          icon: "mdi-clipboard-file",
          show: false,
        },
        {
          text: "Etat des lieux vélo",
          href: "etat-des-lieux-velo",
          color: "#8D6E63",
          icon: "mdi-clipboard-file",
          show: false,
        },
        {
          text: "Gestion livraison",
          href: "gestion-livraison",
          color: "#BDBDBD",
          icon: "mdi-map",
          show: false,
        },
        {
          text: "Signature en ligne",
          href: "signature-en-ligne",
          color: "#BDBDBD",
          icon: "mdi-draw",
          show: false,
        },
        {
          text: "SAV Gestion",
          href: "sav-gestion",
          color: "#BDBDBD",
          icon: "mdi-tools",
          show: false,
        },
        {
          text: "Contrat Gestion",
          href: "contrat-gestion",
          color: "#BDBDBD",
          icon: "mdi-file-document-outline",
          show: false,
        },
        {
          text: "Configuration",
          href: "configuration",
          color: "#607D8B",
          icon: "mdi-cog",
          show: false,
        },
        {
          text: "Logs Web",
          href: "web-logs",
          color: "#5C6BC0",
          icon: "mdi-math-log",
          show: false,
        },
        {
          text: "SAV Web",
          href: "sav-web",
          color: "#BDBDBD",
          icon: "mdi-headset",
          show: false,
        },
        {
          text: "Documentation",
          href: "documentation",
          color: "#1E88E5",
          icon: "mdi-book-open-page-variant-outline",
          show: false,
        },
      ],
    };
  },
  mounted() {
    this.updateUser();
    console.log(this.$store.state);
    this.selectedPage = window.location.pathname.replace("/", "");
  },
  methods: {
    updateUser() {
      let that = this;
      let token = localStorage.getItem("userToken");
      let nbrDivision = this.$route.path.split("/").filter((val) => val.length > 0)
        .length;
      if (nbrDivision <= 1) {
        console.log("token", token);
        
        engine.get_user_by_token(token, function (data) {
          console.log("get_user_by_token", data);

          if (data.code == 0) {
            that.webApplicationToShow = data.data.data.data[0].fieldData.web_application_to_show.split(
              ","
            );
            console.log("that.webApplicationToShow", that.webApplicationToShow);
            
            for (let i = 0; i < that.webApplicationToShow.length; i++) {
              // Sécurité : si le backend renvoie un href absent de la liste,
              // find() renvoie undefined → on ignore au lieu de planter toute l'app.
              let item = that.items.find(
                (val) => val.href == that.webApplicationToShow[i]
              );
              if (item) item.show = true;
            }
            console.log("store", that.$store);

            that.$store.state.webApplicationToShow = that.webApplicationToShow;
            let user = data.data.data.data[0].fieldData;
            delete user.user_id;
            delete user.user_password;
            that.$store.state.user = user;
          } else {
            that.$router.push("/login");
          }
          that.isLoading = false;
        });
      } else {
        that.isLoading = false;
      }
    },
    logOut() {
      // localStorage.clear();
      localStorage.setItem("userToken", undefined);
      this.goTo("/login");
    },
    goTo(href) {
      this.$router.push(href);
    },
  },
  computed: {
    getBackgroundColor() {
      let url = this.$route.fullPath.replace("/", "");
      let color = "#90A4AE";
      let colorTab = {
        "": "#EEF1F7", // accueil : même fond clair que SAV Web
        login: "#E0E0E0",
        "planning-disponibilite": "#90A4AE",
        "planning-livraison": "#90A4AE",
        "planning-operateur": "#90A4AE",
        "planning-gestion-rdv-velo": "#90A4AE",
        "email-visualisation": "#90A4AE",
        "etat-des-lieux-materiel": "#90A4AE",
        statistiques: "#90A4AE",
        "gestion-livraison": "#90A4AE",
        "signature-en-ligne": "#90A4AE",
        "sav-gestion": "#90A4AE",
        "sav-web": "#EEF1F7", // fond clair, même couleur que le module SAV Web
        "web-logs": "#EEF1F7", // même fond clair que Tickets SAV
        documentation: "#EEF1F7",
      };
      if (colorTab[url] != undefined) color = colorTab[url];
      return color;
    },
    getAppBarTitile() {
      return "ACCEN - Web applications";
    },
    // Module affiché dans le fil d'Ariane (nom et icône du menu, sinon nom de la route)
    currentApp() {
      const href = this.$route.path.replace(/^\//, "").split("/")[0];
      const item = this.items.find((i) => i.href === href);
      if (item) return { text: item.text, icon: item.icon };
      const name = href.replace(/-/g, " ");
      return { text: name.charAt(0).toUpperCase() + name.slice(1), icon: "mdi-apps" };
    },
    userName() {
      const u = (this.$store && this.$store.state && this.$store.state.user) || {};
      return String(u.user_name || "").trim();
    },
    userInitials() {
      const parts = this.userName.split(/[\s.-]+/).filter(Boolean);
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase(); // « Christian » → CH
      return ((parts[0] || "").charAt(0) + (parts[1] || "").charAt(0)).toUpperCase() || "?";
    },
    getApp() {
      if (this.$route.fullPath == "/") return "";

      let path = this.$route.fullPath
        .replace("/", "")
        .replaceAll("-", " ")
        .split("?")[0]
        .toUpperCase();

      return path;
    },
    showHeader() {
      // let show = ["/", "/login"];

      let query = this.$route.query;

      if (query && query.header && query.header == "hide") return false;
      else return true;
      // return !show.includes(this.$route.fullPath);
    },
    isHomePage() {
      let show = ["/"];
      return show.includes(this.$route.fullPath);
    },
  },
  components: {
    WifiState,
  },
};
</script>

<style>
@import "./style.css";

/* ── En-tête de l'application (barre blanche épurée) ─────────────────── */
.v-app-bar.acc-bar {
  background: #ffffff !important;
  border-bottom: 1px solid #e3e7f0 !important;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.05) !important;
}
.acc-bar .v-toolbar__content {
  padding: 0 !important;
}
.acc-bar-in {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 100%;
  padding: 0 20px;
  color: #1b2440;
}
.acc-logo {
  flex: none;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(150deg, #5c6bc0 0%, #3949ab 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
}
.acc-brand {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
  min-width: 0;
}
.acc-brand b {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.02em;
}
.acc-brand span {
  font-size: 11.5px;
  font-weight: 600;
  color: #8a93ab;
}
.acc-crumb {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
}
.acc-crumb-home {
  color: #8a93ab;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}
.acc-crumb-home:hover {
  color: #3d4ed8;
}
.acc-crumb-sep {
  color: #b4bcd0;
}
.acc-crumb-cur {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1b2440;
}
.acc-crumb-cur .v-icon {
  color: #3d4ed8;
}
.acc-sp {
  flex: 1 1 auto;
}
.acc-icon-btn {
  flex: none;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e3e7f0;
  border-radius: 10px;
  background: #ffffff;
  color: #5b6478;
  cursor: pointer;
  transition: background-color 0.12s, color 0.12s, border-color 0.12s;
}
.acc-icon-btn:hover {
  background: #f3f5fb;
  color: #3d4ed8;
  border-color: #d4daf0;
}
.acc-logout:hover {
  background: #fdecea;
  color: #d32f2f;
  border-color: #f6c9c5;
}
.acc-user {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 220px;
  padding: 4px 12px 4px 4px;
  border: 1px solid #e3e7f0;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
}
.acc-av {
  flex: none;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #5c6bc0;
  color: #ffffff;
  font-size: 11.5px;
  font-weight: 800;
}
.acc-user-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Mobile : on garde l'essentiel (retour, module, connexion, avatar, déconnexion) */
@media (max-width: 600px) {
  .acc-bar-in {
    gap: 8px;
    padding: 0 10px;
  }
  .acc-crumb-home,
  .acc-crumb-sep,
  .acc-user-name {
    display: none;
  }
  .acc-user {
    padding: 2px;
  }
}
</style>
